import { differenceInDays } from 'date-fns'

export const getDifferenceInDays = (date: string | undefined) => {
  if (!date) {
    return ''
  }

  const days = differenceInDays(new Date(date), new Date())

  if (days === 0) {
    return ''
  }

  return `${days} days`
}
